import washingMachineFL from '../assets/productImages/FL.png';
import refrigerator from '../assets/productImages/Ref FF.png';
import clothesDryer from '../assets/productImages/CD.png';
import logo from '../assets/images/logo.png';

export const getProductImageByName = (productName: string | null | undefined): string => {
  if (!productName) {
    return logo;
  }

  switch (productName) {
    case 'Washing Machine':
      return washingMachineFL;
    case 'Refrigerator':
      return refrigerator;
    case 'Clothes Dryer':
      return clothesDryer;
    default:
      return logo;
  }
};
